// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3oyBy","author":"Table_author__3QW9V","authorImage":"Table_authorImage__2RWjK","unreadRow":"Table_unreadRow__1lBeO"};